export default "__VITE_ASSET__DvgZ5o8V__"